import { createAsyncAction, getType } from "typesafe-actions";
import { call, put, takeLatest } from "typed-redux-saga";
import { createSlice } from "@reduxjs/toolkit";
import { mapAPIErrorResponse } from "Models/Errors/ApiCallError";
import {
	getFetchStateDefaultValue,
	handleFailureCase,
	handleRequestCase,
	handleSuccessCase,
} from "State/Utils";
import {
	getInvoicesUserIssuedInvoicesISDOCPdfsAvailableYears,
	GetUserIssuedInvoicesAvailableYearsQueryResult,
} from "Api/Api";

export const getUserIssuedInvoicesAvailableYearsAsync = createAsyncAction(
	"@invoice/GET_AVAILABLE_YEARS_ISSUED_REQUEST",
	"@invoice/GET_AVAILABLE_YEARS_ISSUED_RESPONSE",
	"@invoice/GET_AVAILABLE_YEARS_ISSUED_FAILURE",
)<void, GetUserIssuedInvoicesAvailableYearsQueryResult, Error>();

function* getUserIssuedInvoicesAvailableYears(): Generator {
	try {
		const { data, error, status } = yield* call(
			getInvoicesUserIssuedInvoicesISDOCPdfsAvailableYears,
		);

		if (status === 200) {
			yield put(getUserIssuedInvoicesAvailableYearsAsync.success(data));
			return;
		}

		yield put(
			getUserIssuedInvoicesAvailableYearsAsync.failure(
				mapAPIErrorResponse(error ?? data),
			),
		);
	} catch (err) {
		yield put(getUserIssuedInvoicesAvailableYearsAsync.failure(err as Error));
	}
}

export function* getUserIssuedInvoicesAvailableYearsSaga() {
	yield takeLatest(
		getType(getUserIssuedInvoicesAvailableYearsAsync.request),
		getUserIssuedInvoicesAvailableYears,
	);
}

export const getUserIssuedInvoicesAvailableYearsSlice = createSlice({
	initialState:
		getFetchStateDefaultValue<GetUserIssuedInvoicesAvailableYearsQueryResult>(
			false,
		),
	name: "@invoice/getUserIssuedInvoicesAvailableYears",
	reducers: {},
	extraReducers: builder => {
		handleRequestCase(getUserIssuedInvoicesAvailableYearsAsync, builder);
		handleSuccessCase(getUserIssuedInvoicesAvailableYearsAsync, builder);
		handleFailureCase(getUserIssuedInvoicesAvailableYearsAsync, builder);
	},
});
